export default __webpack_public_path__ + "assets/pdf.25c19fbb11dacc87994bdce830d7e5ed.png";